import BaseAPI from '@/apis/base/baseApi';
import commonFn from '@/commons/commonFunction';
import httpclient, {FormMultiPart} from '../base/httpclient';
class FileAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'File';
  controllerName = 'Files';

  /**
   * lấy link gọi download file
   * @param {*} type : File gì
   * @param {*} file : tên file server
   * @param {*} name : Tên file lưu về
   * @param {*} tenant :Dữ liệu công ty nào
   */
  getDownloadLink(type, file, name, tenant) {
    let url = [this.getAPIUrl(), 'download', type.toString()];
    if (file) {
      if (tenant) {
        url.push(tenant);
      }

      url.push(file);

      if (name) {
        url.push(name);
      }
    }
    url = url.filter(function (item) {
      return item;
    });
    return url.join('/');
  }

  /**
   * Check xem file đã có trên temp chưa
   * @param {*} fileName
   * @return Promise
   */
  checkTempFile(fileName) {
    const url = [this.getAPIUrl(), 'check-temp', fileName].join('/');
    return this.getAsync({url});
  }

  /**
   * lấy link gọi file
   * trả về content-type theo type - không force downoad
   * @param {*} type : File gì
   * @param {*} file : tên file server
   * @param {*} name : Tên file lưu về
   */
  getFileLink(type, file, name, tenant) {
    let url = [this.getAPIUrl(), type.toString()];
    if (file) {
      if (tenant) {
        url.push(tenant);
      }

      url.push(file);

      if (name) {
        url.push(name);
      }
    }
    url = url.filter(function (item) {
      return item;
    });
    return url.join('/');
  }

  /**
   * Lấy link preview inline
   * @param {*} type
   * @param {*} file
   * @param {*} name
   * @param {*} tenant
   * @returns
   */
  getFilePreviewLink(type, file, name, tenant) {
    let url = [this.getAPIUrl(), 'preview', type.toString()];
    if (file) {
      if (tenant) {
        url.push(tenant);
      }

      url.push(file);

      if (name) {
        url.push(name);
      }
    }
    url = url.filter(function (item) {
      return item;
    });
    return url.join('/');
  }

  async getFile(url) {
    return await this.getAsync({url});
  }
  /**
   * Upload file
   * @param {*} file : File upload
   * @param {*} type : Loại file
   */
  upload(file, type) {
    const data = new FormData();
    data.append('file', file);
    if (type) {
      data.append('type', type);
    }

    const request = {
      url: this.getAPIUrl(),
      data: data,
    };

    return this.postAsync(request, true, true, FormMultiPart);
  }

  /**
   * Upload nhiều file
   * @param {*} files : File upload
   * @param {*} type : Loại file
   */
  uploads(files, type) {
    const data = new FormData();
    files.forEach(file => {
      data.append('file', file, file.name);
    });
    if (type) {
      data.append('type', type);
    }

    const request = {
      url: [this.getAPIUrl(), 'multi'].join('/'),
      data: data,
    };

    return this.postAsync(request);
  }

  /**
   * lấy link gọi file
   * trả về content-type theo type - không force downoad
   * @param {*} type : File gì
   * @param {*} name : tên file server
   * @param {*} width : độ rộng ảnh
   * @param {*} height : chiều dài ảnh
   * @param {*} quantity : độ phân giải
   */
  getImageLink(type, name, width, height, quantity) {
    const url = [this.getAPIUrl(), 'image', type];
    if (name) {
      url.push(name);
      if (width) {
        url.push(width);
      }
      if (height) {
        url.push(height);
      }
    }
    const context = JSON.parse(commonFn.getLocalStorage('Context'));
    if (context.TenantID) {
      url.push(context.TenantID);
    }
    if (quantity) {
      url.push(quantity);
    }

    return url.join('/');
  }
  deleteFile(type, fileName) {
    return this.deleteAsync({url: [this.getAPIUrl(), type, fileName].join('/')});
  }

  /**
   * Call API tải tệp mẫu nhập khẩu phát hành séc
   * @returns {Promise} - File template Nhap_Khau_Phat_Hanh_Sec.xlsx
   */
  async downloadChequeImportTemplate() {
    const request = {
      url: this.getAPIUrl() + '/template/cheque-import',
      responseType: 'blob',
    };

    return await httpclient.getAsync(request, true, true);
  }

  /**
   * Call API tải tệp mẫu nhập khẩu phiếu nhập kho
   * @returns {Promise} - File template Nhap_Khau_Phieu_Nhap_Kho.xlsx
   */
  async downloadInwardImportTemplate() {
    const request = {
      url: this.getAPIUrl() + '/template/inward-import',
      responseType: 'blob',
    };

    return await httpclient.getAsync(request, true, true);
  }
}

export default new FileAPI();
